<div class="recuadro-condicion flex-grow-1 d-flex">
    <app-condicion-si-contesto *ngIf="condicion?.tipo === TipoCondicionEnum.CONTESTO" [encuesta]="encuesta!"
        [condicion]="condicion!" [pregunta]="pregunta" [item]="item">
    </app-condicion-si-contesto>
    <app-condicion-su-genero-es *ngIf="condicion?.tipo === TipoCondicionEnum.GENERO" [condicion]="condicion!">
    </app-condicion-su-genero-es>
    <app-condicion-su-pais-es *ngIf="condicion?.tipo === TipoCondicionEnum.PAIS" [condicion]="condicion!">
    </app-condicion-su-pais-es>
    <app-condicion-si-tiene-tag *ngIf="condicion?.tipo === TipoCondicionEnum.TAG" [condicion]="condicion!">
    </app-condicion-si-tiene-tag>
</div>
